export type CardKcalConfig = number | null | undefined;

export const DEFAULT_CARD_KCAL_PER_USE = 200;

export type IntakeCardLike = {
    tier?: string | null;
    kcalPerUse?: number | null;
    logKcalOnUse?: boolean | null;
};

export function cardKcalFromApi(card: IntakeCardLike): CardKcalConfig {
    if (card.kcalPerUse != null && card.kcalPerUse > 0) return card.kcalPerUse;
    if (card.logKcalOnUse) return DEFAULT_CARD_KCAL_PER_USE;
    return null;
}

export function tierTracksCalorieIntake(tier: string | undefined | null): boolean {
    return tier !== 'special';
}

export function cardHasCalorieConfig(kcal: CardKcalConfig): boolean {
    return typeof kcal === 'number' && kcal > 0;
}

export function cardCountsTowardIntake(c: { tier?: string | null; kcal?: CardKcalConfig }): boolean {
    if (!tierTracksCalorieIntake(c.tier ?? undefined)) return false;
    if (c.tier === 'healthy' || c.tier === 'limited') return cardHasCalorieConfig(c.kcal);
    return true;
}

export function intakeKcalForCardUse(card: IntakeCardLike, kcalAmount?: number | null): number {
    const kcal = cardKcalFromApi(card);
    if (!cardCountsTowardIntake({ tier: card.tier ?? undefined, kcal })) return 0;
    if (kcalAmount != null && kcalAmount > 0) return Math.round(kcalAmount);
    if (typeof kcal === 'number') return kcal;
    return 0;
}

export function totalIntakeKcalFromUsages(
    usages: readonly { cardId: string; kcalAmount?: number | null }[],
    cardById: ReadonlyMap<string, IntakeCardLike>,
): number {
    return usages.reduce((sum, u) => {
        const card = cardById.get(u.cardId);
        if (!card) return sum;
        return sum + intakeKcalForCardUse(card, u.kcalAmount);
    }, 0);
}
